var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", { staticClass: "collapsed-text align-measureText" }, [
        _vm._v("MEASURE"),
      ]),
      _vm._v(" "),
      !_vm.showMeasuringTool
        ? _c("fa", {
            class: "collapsed-symbol " + "collapsed-gray",
            attrs: { icon: ["fas", "ruler"], size: "2x" },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.measure && _vm.showMeasuringTool
        ? _c("span", { staticClass: "collapsed-text textAtBottom" }, [
            _c("strong", { staticClass: "text-wrap" }, [
              _vm._v(_vm._s(_vm.measurement[0])),
            ]),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c("strong", { staticClass: "text-wrap" }, [
              _vm._v(_vm._s(_vm.measurement[1])),
            ]),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c("strong", { staticClass: "clickToStop" }, [
              _vm._v("CLICK TO STOP"),
            ]),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }